var opotins = {
    now: '00:00',
    title: 'ساعت مشاوره',
    twentyFour: true
};


$(function () {
    $(document).scroll(function () {
        if ($(this).scrollTop() >= $('#content').offset().top - 200 && $(this).scrollTop() <= $('#price-sec').offset().top) {
            $("#navigation-menu").addClass("show-menu");
        } else {
            $("#navigation-menu").removeClass("show-menu");
        }
        if ($(this).scrollTop() > $('footer').offset().top - 200) {
            $('.i-section').css('display', 'none');

        } else {
            $('.i-section').css('display', 'block');
        }
    });
});


$("#navigation-menu a,a[href='#top'],a[rel='m_PageScroll2id']").mPageScroll2id({
    highlightSelector: "#navigation-menu a"
});
$("a[rel='next']").click(function (e) {
    e.preventDefault();
    var to = $(this).parent().parent("section").next().attr("id");
    $.mPageScroll2id("scrollTo", to);
});


$(document).ready(function () {

    $("#user_login_form .requieredInput").keyup(function(event) {
        var text = $(this).val();
        $("#AlertError").hide()
        $("#mobile").css("border","none")

    });
    $("#user_login_form").submit(function(evt){

        var requierdinputs = $('#user_login_form .requieredInput')
        var valueMobile = $('#user_login_form #mobile').val();
        var status;
        requierdinputs.each(function () {
            if ($(this).val() == '') {
                var name = $(this).attr('placeholder')
                // alert('فیلد ' + name + ' را پر کنید ');
                $("#AlertError").show()

                $("#AlertError").text('فیلد ' + name + ' را پر کنید ')
                $("#mobile").css("border","1px solid #b71c1c")
                status = 'error'
                return false
            }
        });


        if(status != 'error' && !validateMobile(valueMobile, '')){
            status = 'error'
            $("#AlertError").show()

            $("#AlertError").text('فرمت شماره موبایل وارد شده اشتباه است ')
            $("#mobile").css("border","1px solid #b71c1c")


        }else if(status == 'error'){
            return false;
        }

        evt.preventDefault();
        if(status != 'error') {
            var formData = new FormData($(this)[0]);

            $.ajax({
                url: 'users/dashboard/index.php',
                type: 'POST',
                data : formData ,
                async: false,
                cache: false,
                contentType: false,
                processData: false,
                success: function (response) {

                    // $('#g-recaptcha-response').reset();
                    $('#g-recaptcha-response').val('');
                    grecaptcha.reset();
                    const res=JSON.parse(response)

                    if(res.success == true){
                        // alert('شما با موفقیت وارد شدید.')
                        document.location.href = '/users';
                    }else{
                        $('#RasData').text(res.data)
                        $('#unsuccessfullModal').modal('show');
                    }

                }
            });
        }


        return false;

    });


    var requierdinputsa = $('#user_register_form .requieredInput')
    requierdinputsa.each(function () {
        $("#user_register_form .requieredInput").keyup(function(event) {
            var texts = $(this).val();
            var id = '#AlertError'+ $(this).attr('name')

            $(id).hide()
            $('#'+$(this).attr('name')).css('border','none')


        });

    });

    $("#user_register_form").submit(function(evt){

        var requierdinputs = $('#user_register_form .requieredInput')
        var valueMobile = $('#user_register_form #PhoneNumber').val();
        console.log(valueMobile)
        var ValueUrl = $('#user_register_form #Url').val();
        console.log(ValueUrl)
        var ValueInstaLink = $('#user_register_form #InstagramUrl').val();
        console.log(ValueInstaLink)
        var status;
        requierdinputs.each(function () {
            if ($(this).val() == '') {
                var name = $(this).attr('placeholder')
                var id = '#AlertError'+ $(this).attr('name')
                $(id).show()
                $(id).text('فیلد ' + name + ' را پر کنید ')
                $('#'+$(this).attr('name')).css('border','1px solid rgb(183, 28, 28)')
                status = 'error'
                return false
            }
            else {
                var id = '#AlertError'+ $(this).attr('name')
                $(id).hide()
                $('#'+$(this).attr('name')).css('border','none')
            }
        });

        if(status != 'error' && !validateMobile(valueMobile, '')){
            status = 'error';
            $("#AlertErrorPhoneNumber").show()
            $("#AlertErrorPhoneNumber").text('فرمت شماره موبایل وارد شده اشتباه است ')
            //alert('فرمت شماره موبایل وارد شده اشتباه است ');
        }else if(status != 'error' && !validateUrl(ValueUrl, '')){
            status = 'error';
            $("#AlertErrorUrl").show()
            $("#AlertErrorUrl").text('فرمت آدرس سایت وارد شده اشتباه است ')
            //alert('قرمت آدرس سایت وارد شده اشتباه است ');
        }else if(status != 'error' && !validateInstaLink(ValueInstaLink, '')){
            status = 'error';
            $("#AlertErrorInstagramUrl").show()
            $("#AlertErrorInstagramUrl").text('قرمت ایدی اینستاگرام وارد شده اشتباه است ')
            //alert('قرمت ایدی اینستاگرام وارد شده اشتباه است ');
        }else if(status == 'error'){
            return false;
        }
        if(status != 'error') {
            var formData = new FormData($(this)[0]);
            $.ajax({
                url: 'users/dashboard/index.php',
                type: 'POST',
                data: formData,
                async: false,
                cache: false,
                contentType: false,
                processData: false,
                success: function (response) {

                    // $('#g-recaptcha-response').reset();
                    $('#g-recaptcha-response').val('');
                    grecaptcha.reset();
                    const res = JSON.parse(response)

                    if (res.success == true) {
                        // alert('شما با موفقیت وارد شدید.')
                        document.location.href = '/users';
                    } else {
                        //alert(res.data)
                        $('#RasData').text(res.data)
                        $('#unsuccessfullModal').modal('show');
                    }

                }
            });
        }
        evt.preventDefault();
        return false;
    });

    $('.timepicker').wickedpicker(opotins);
    // setTimeout(function () {
    //     // $('.irantech-service-crousel .owl-dot:nth-child(3)').trigger('click');
    // }, 1000);
    // if ($(window).width() < 557) {
    //     $('.special-item .service-item-box img').attr('src', 'https://www.iran-tech.com/pic/news/banneradv-res.jpg')
    //
    // } else {
    //     $('.special-item .service-item-box img').attr('src', 'https://www.iran-tech.com/pic/news/banneradv.jpg')
    //
    // }

    var now = new Date();
    var full_year = now.getFullYear();
    $('.copy_right').append(full_year);

    $(window).scroll(function () {
        var y = $(window).scrollTop();

        $(".nemoone-section").filter(function () {
            return $(this).offset().top < (y + $(window).height()) &&
                $(this).offset().top + $(this).height() > y;
        }).css('background-position', parseInt(-y / 45) + 'px ' + parseInt(-y / 42) + 'px');

        var sctop = $(this).scrollTop();

        if (sctop > 50) {

            $('header').addClass('fixed_menu');
        } else {
            $('header').removeClass('fixed_menu');

        }


    });


    $(".price-list-btn").click(function () {


        $([document.documentElement, document.body]).animate({
            scrollTop: $("#price-sec").offset().top
        }, 0);
        $(this).parents(".i-section").find(".i-btn").removeClass("remove-i-btn");
        $(this).parents(".i-section").find(".i-info").removeClass("remove-i-info");
        $(this).parents(".i-section").find(".i-info-show").removeClass("show-i-info-show");

    });
    $('.timepicker_and').mdtimepicker({
        is24hour: true,
        theme: 'red',
    });

    function focusOnSearchBox(items) {
        if(window.location.hash) {
            const target=$(items);
            const location_hash = window.location.hash;
            const location_hash_val=location_hash.replace('#','')
            $.each(entries, function (key, data) {
                $.each(data, function (index, data) {
                    if(index === location_hash_val){
                        target.find(`a[href="#${data}"]`).tab('show')
                        scrollTo({
                            top: 0,
                            behavior: 'smooth'
                        });

                    }
                })
            })
            if(window.history.pushState) {
                window.history.pushState('', '/', window.location.pathname)
            } else {
                window.location.hash = '';
            }
        } else {
        }
    }

    $('.go-price').click(function() {
        $('html, body').animate({
            scrollTop: $("#price-sec").offset().top
        }, 2000);
        // const target=$('#price-sec');
        // const location_hash = window.location.hash;
        // const location_hash_val=location_hash.replace('#','')
        // target.find(`a[href="#price-sec"]`).tab('show')
        // scrollTo({
        //     top: 0,
        //     behavior: 'smooth'
        // });
    });



    $(".i-btn").click(function () {
        $(this).addClass("remove-i-btn");
        $(this).parents(".i-section").find(".i-info").addClass("remove-i-info");
        $(this).parents(".i-section").find(".i-info-show").addClass("show-i-info-show");
    });
    $(".i-info-show > span").click(function () {
        $(this).parents(".i-section").find(".i-btn").removeClass("remove-i-btn");
        $(this).parents(".i-section").find(".i-info").removeClass("remove-i-info");
        $(this).parents(".i-section").find(".i-info-show").removeClass("show-i-info-show");

    });
    /*$(".nano").nanoScroller();*/

    $(".mob-menu-btn").click(function () {
        $("body,html").css("overflow-y", "hidden");
        $(".background-modal-box").show();
        $(".irantech-menu").animate({
            right: '0px'
        });
    });
    $(".background-modal-box").click(function () {
        $("body,html").css("overflow-y", "auto");
        $(this).hide();
        $(".irantech-menu").animate({
            right: '-312px'
        });
    });
    $(".has-child a").click(function () {
        $(this).parents(".has-child").find(".megasub").toggle();
        $(this).parents(".has-child").toggleClass("rotate-45-before");
    });
    $(".has-sub a").click(function () {
        $(this).parents(".has-sub").find(".submenu").toggle();
        $(this).parents(".has-sub").toggleClass("rotate-45-before");
    });

    $('body').click(function (evt) {
        if (!$(evt.target).is('#know-us-box')) {

            $('.price-request-know-item').removeClass('know-us-show');

            if ($('.checkbox-label').hasClass('lbl-go-top') && $('#valueCheckbox').is(':empty')) {
                $('.checkbox-label').removeClass('lbl-go-top');
            }


        }
    });

    $('#know-us-box').bind('click', function (e) {
        //as when we click inside the menu it bubbles up and closes the menu when it hits html we have to stop the propagation while its open
        e.stopPropagation();
    });
    $('#activity-type-box').bind('click', function (e) {
        //as when we click inside the menu it bubbles up and closes the menu when it hits html we have to stop the propagation while its open
        e.stopPropagation();
    });

    $("#p-r-know").click(function () {
        setTimeout(function () {
            $(".price-request-know-item").addClass("know-us-show");
            $(".checkbox-label").addClass("lbl-go-top");

        }, 10);
    });
    $('.remove_icon').click(function () {
        $(".price-request-know-item").removeClass("know-us-show");
        if ($('.checkbox-label').hasClass('lbl-go-top') && $('#valueCheckbox').is(':empty')) {
            $('.checkbox-label').removeClass('lbl-go-top');
        }
        $('.price-request-activity-item').removeClass('know-us-show');

    })

    $(".typeRelationCheckbox").on('click', function () {
        var i = 0;
        $('#valueCheckbox').html('');
        $(".typeRelationCheckbox").each(function () {
            $(this).prop("disabled", false);
            var check = $(this).prop('checked');
            var value = $(this).val();
            if (check == true) {
                $('#valueCheckbox').append('<span><i></i> ' + value + ' </span>');
                i++;
            }
        });

        $(".typeRelationCheckbox").each(function () {
            var check = $(this).prop('checked');
            if (i > 2 && check == false) {
                $(this).prop("disabled", true);
            }
        });

    });


    $('body').click(function (evt) {
        if (!$(evt.target).is('#activity-type-box')) {

            if ($('.price-request-activity-item').hasClass('know-us-show')) {
                $('.price-request-activity-item').removeClass('know-us-show');
            }
            if ($(".checkbox-label-activity").hasClass('lbl-go-top') && $('#valueCheckboxactivity').is(':empty')) {
                $(".checkbox-label-activity").removeClass('lbl-go-top');
            }


        }
    });

    $("#p-r-activity").click(function () {
        setTimeout(function () {
            $(".price-request-activity-item").addClass("know-us-show");
            $(".checkbox-label-activity").addClass("lbl-go-top");

        }, 10);
    });

    $(".typeActivityCheckbox").on('click', function () {
        var i = 0;
        $('#valueCheckboxactivity').html('');
        $("#activity-error").addClass("d-none");
        $(".price-request-activity-item").removeClass("know-us-show");
        $(".typeActivityCheckbox").each(function () {
            $(this).prop("disabled", false);
            var check = $(this).prop('checked');
            var value = $(this).val();
            if (check == true) {
                var result = value.split('##');
                $('#valueCheckboxactivity').append('<span><i></i> ' + result[1] + ' </span>');
                $('#activity').val(result[0]);
                i++;
            }
        });
        // $(".typeActivityCheckbox").each(function () {
        //     var check = $(this).prop('checked');
        //     if (i > 0 && check == false){
        //         $(this).prop("disabled", true);
        //     }
        // });


    });


    $('.irantech-service-crousel').owlCarousel({
        items: 2,
        rtl: true,
        loop: true,
        margin: 15,
        navText: ["<i class='fas fa-chevron-right'></i>","<i class='fas fa-chevron-left'></i>"],
        dotsEach: 3,
        dots: true,
        center: true,
        autoplay: false,
        autoplayTimeout: 13000,
        autoplaySpeed: 2000,
        responsive: {
            0: {
                items: 1,
                margin: 15,
                nav:true,

            },
            575: {
                items: 2,
                autoWidth: true,
                margin: 0,

            },
            768: {
                items: 2,
                autoWidth: true,
                margin: 0,
            },
            992: {
                items: 2,
                autoWidth: true,
                margin: 5,
            },
            1200: {
                items: 2,
                autoWidth: true,
            }
        }
    });


    $('.select2').select2();
    $('.select2-num').select2();

    $('.circles-carousel').owlCarousel({
        items: 1,
        rtl: true,
        margin: 0,
        loop: true,
        dots: false,
        autoplay: true,
        autoplayTimeout: 3500,
        autoplaySpeed: 300,
        //	autoplayHoverPause:true,
    });


    $('.under-c-carousel').owlCarousel({
        items: 4,
        rtl: true,
        //	margin:20,
        dots: false,
        //	center:true,
        //	loop:true,
        //	autoplay:true,
        //	autoplayTimeout:3500,
        //	autoplaySpeed:1000,
        autoplayHoverPause: true,
        nav: true,
        responsive: {
            0: {
                items: 1,
                autoplay: true,
                nav: false,

            },
            575: {
                items: 2,
                center: false,
                margin: 0,
                nav: false,
                autoplay: true,

            },
            768: {
                items: 2,
                margin: 0,
                nav: false,
                autoplay: true,
            },
            992: {
                items: 3,
                center: false,
                margin: 0,
                autoplay: true,
            },
            1200: {
                items: 4,
                nav: true,

            }
        }
    });


});

window.nextcode = function (eleman) {
    if ($(eleman).val() != '') {
        $(eleman).prev().focus();
    }
}

$(".num-under-c").focus(function () {
    $(this).select();
});


window.send_user = function (i) {
    var code = '';
    $("#form_tarahi" + i).children('input[name=code_trahi]').each(function () {
        code = (this.value) + code;
    });
    var id_project = $("#id_tarahi" + i).val();
    $.post("code_fun/send_user_to_panel.php", {id: code, id_project: id_project}, function (data) {
        if ($.trim(data) == 0) {
            $("#description_form_tarahi" + i).css('display', 'block');
            $("#description_form_tarahi" + i).html('کد وارد شده اشتباه می باشد.');
        } else {
            document.location.href = data;
        }

    });
}


$.validator.setDefaults({
    submitHandler: function () {
        $('#but_order_cost').attr('disabled','disabled')
        var name = $("#name_manager").val();
        var email = $("#email_manager").val();
        var mobile = $("#mob_manager").val();
        var agency = $("#nama_agency").val();
        var tel = $("#tel_agency").val();
        var Advice_day = $("#Advice_day").val();
        var Advice_time = $("#Advice_time").val();
        var allow_peygiri = $('#allow_peygiri').prop('checked');
        var req_type = '';
        var relation = '';
        var comment = $("#request_comment").val();
        var activity_type = $("#activity").val();
        var recaptcha = $("#g-recaptcha-response").val();

        $.each($("input[name='type_req']:checked"), function () {
            req_type += $(this).val() + ',';
        });

        $.each($("input[name='type_relation']:checked"), function () {
            relation += $(this).val() + ',';
        });
        $.ajax({
            type: 'POST',
            url: 'parvaz/code_fun/order_cost.php',
            data: {
                nama_agency: agency,
                name_manager: name,
                email_manager: email,
                mob_manager: mobile,
                tel_agency: tel,
                type_order: req_type,
                relation: relation,
                comment: comment,
                Advice_day: Advice_day,
                Advice_time: Advice_time,
                allow_peygiri: allow_peygiri,
                recaptcha: recaptcha,
                activity_type: activity_type
            },
            success: function (data) {
                $('#but_order_cost').removeAttr('disabled');
                var edited_data=data.replace(/\n|\r/g, "");
                console.log(edited_data)

                if(edited_data !=='recaptcha_error'){
                    window.location.href = "price_parvaz/html_pdf.php?name_manager=" + name + "&code=" + data + "&activity=" + activity_type;
                }else{
                    alert('لطفا گزینه من ربات نیستم را بزنید')
                }
            }
        })
    }
});
$().ready(function () {

    // validate signup form on keyup and submit
    $("#myform").validate({
        rules: {
            name_manager: "required",
            mob_manager: {
                required: true,
                digits: true
            },
            tel_agency: {
                digits: true
            },
            email_manager: {
                email: true
            },

            // count_type_request: "required",
            activity: "required"
        },
        messages: {
            name_manager: "لطفا نام و نام خانوادگی خود را وارد کنید",
            mob_manager: {
                required: "لطفا شماره موبایل را وارد کنید",
                digits: "لطفا فقط عدد وارد کنید."
            },
            tel_agency: {
                digits: "لطفا فقط عدد وارد کنید."
            },
            email_manager: {
                email: "فرمت ایمیل صحیح نمی باشد."
            },

            // count_type_request: {
            //     required: "کاربر گرامی لطفا حداقل یکی از گزینه ها را انتخاب کنید"
            // },
            activity: {
                required: "کاربر گرامی لطفا یکی از گزینه ها را انتخاب کنید"
            }
        }
    });
});


$(function () {
    $('[id*=mob_manager]').keyup(function (e) {
        var ctrlKey = 67, vKey = 86;
        if (e.keyCode != ctrlKey && e.keyCode != vKey) {
            $('[id*=mob_manager]').val(persianToEnglish($(this).val()));
        }
    });
});


$(function () {
    $('[id*=tel_agency]').keyup(function (e) {
        var ctrlKey = 67, vKey = 86;
        if (e.keyCode != ctrlKey && e.keyCode != vKey) {
            $('[id*=tel_agency]').val(persianToEnglish($(this).val()));
        }
    });
});

window.persianToEnglish = function (input) {
    var inputstring = input;
    var persian = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"]
    var english = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]
    for (var i = 0; i < 10; i++) {
        var regex = new RegExp(persian[i], 'g');
        inputstring = inputstring.toString().replace(regex, english[i]);
    }
    return inputstring;
}


window.checktypereq = function () {
    var count = 0;
    $(".type_req").each(function () {
        if ($(this).is(':checked')) {
            count += 1;
        }
    });

    if (count > 0) {
        if ($("#count_type_request").attr('checked', false)) {
            $("#count_type_request").trigger('click');
            $("#count_type_request").attr('checked', true);
        }

    } else {
        $("#count_type_request").attr('checked', false);
        //$( "#count_type_request" ).trigger('click');

    }
};

function validateMobile(str, NameDiv) {
    if (str.length != 11 || str.slice(0, 2) != "09"){
        return false;
    }
    return true;
}
function validateUrl(str, NameDiv) {
    var expression = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
    var regex = new RegExp(expression);
    if (str.match(regex)){
        return true;
    }
    return false;
}
function validateInstaLink(str, NameDiv) {
    var expression = /^[a-zA-Z0-9._]+$/;
    var regex = new RegExp(expression);
    if (str.match(regex)){
        return true;
    }
    return false;
}

//lazy load start
document.addEventListener("DOMContentLoaded", function () {
    var lazyloadImages;

    if ("IntersectionObserver" in window) {
        lazyloadImages = document.querySelectorAll(".lazy");
        var imageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    var image = entry.target;
                    image.src = image.dataset.src;
                    image.classList.remove("lazy");
                    imageObserver.unobserve(image);
                }
            });
        });

        lazyloadImages.forEach(function (image) {
            imageObserver.observe(image);
        });
    } else {
        var lazyloadThrottleTimeout;
        lazyloadImages = document.querySelectorAll(".lazy");

        function lazyload() {
            if (lazyloadThrottleTimeout) {
                clearTimeout(lazyloadThrottleTimeout);
            }

        }

        document.addEventListener("scroll", lazyload);
        window.addEventListener("resize", lazyload);
        window.addEventListener("orientationChange", lazyload);
    }
})
//lazyload end











